/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");
const axios = require("axios");

import Vue from "vue";
import Vuesax from "vuesax";

import VueCompositionAPI from "@vue/composition-api";
import calculator from "./components/calculator.vue";
import passwordreset from "./components/settings/passwordreset.vue";
import parcels from "./components/parcels/parcels.vue";
import brenchEdit from "./components/settings/brenchEdit.vue";
import addBalance from "./components/balance/addBalance.vue";
import delivery from "./components/delivery.vue";
import profile from "./components/profile.vue";
Vue.use(VueCompositionAPI);
Vue.use(Vuesax, {
    theme: {
        colors: {
            primary: "#f39120",
        },
    },
});
Vue.component("v-calculator", calculator);
Vue.component("v-password-reset", passwordreset);
Vue.component("v-parcels", parcels);
Vue.component("v-brench-edit", brenchEdit);
Vue.component("v-add-balance", addBalance);
Vue.component("v-delivery", delivery);
Vue.component("v-profile", profile);

import "./validate";
import "select2";
// requirec("../assets/vendor/MediaManager/js/manager");

new Vue({
    el: "#app",
});

import localeEn from "air-datepicker/locale/en";
import AirDatepicker from "air-datepicker";
new AirDatepicker("input[data-picker]", {
    locale: localeEn,
});
window.axios = axios;

document.querySelector(".mobile-menu-button").addEventListener("click", () => {
    document.querySelector(".mobile-menu-overlay").style.display = "block";
    document.body.style.overflowY = "hidden";
});
document.querySelector(".mobile-menu-close").addEventListener("click", () => {
    document.querySelector(".mobile-menu-overlay").style.display = "none";
    document.body.style.overflowY = "scroll";
});
